import { useAuth } from '@clerk/clerk-react';
import { useAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';
import {
  endpointFundGET,
  isFundResponseOk,
} from '~/api/def/endpoints/fundEndpoint';
import { fundHierarchyAtom, fundListAtom } from '~/atoms/fundAtoms';
import { fundsToHierarchy } from '~/lib/fund/fundsToHierarchy';

export const useHierarchyEndpoint = () => {
  const [fundHierarchy, setFundHierarchy] = useAtom(fundHierarchyAtom);
  const [fundList, setFundList] = useAtom(fundListAtom);
  const [fundsLoading, setFundsLoading] = useState(false);
  const auth = useAuth();

  const loadHierarchy = useCallback(async () => {
    if (fundsLoading) return;
    setFundsLoading(true);
    return await endpointFundGET().then((res) => {
      if (isFundResponseOk(res)) {
        setFundList(res.data);
        const { hierarchy } = fundsToHierarchy(res.data);

        setFundHierarchy(hierarchy);
      }
      setFundsLoading(false);
      return true;
    });
  }, [fundsLoading, setFundList, setFundHierarchy]);

  useEffect(() => {
    if (auth.isSignedIn && auth.isLoaded && !fundHierarchy) {
      loadHierarchy();
    }
  }, [
    auth.isSignedIn,
    auth.isLoaded,
    fundHierarchy,
    setFundHierarchy,
    loadHierarchy,
  ]);

  return { fundHierarchy, loadHierarchy, fundList } as const;
};
